export default __webpack_public_path__ + "static/media/Image_1.bb75df0c.jpg";